import styled from "styled-components";

export const Container = styled.div``; 

export const ContentProgress = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 30px;
`;